import * as React from 'react';
import { createTheme, responsiveFontSizes  } from '@mui/material/styles';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router';

const LinkBehavior = React.forwardRef((props, ref) => {
  const { href, ...other } = props;
  // Map href (Material UI) -> to (react-router)
  return <RouterLink ref={ref} to={href} {...other} />;
});

const theme = responsiveFontSizes(createTheme({
	typography: {
      fontFamily: ["myriad-variable"],
      //fontSize: 20,
  },
  palette: {
    mode: 'light',
    primary: {
        light: "#857367",
        main: "#E2774A",
        dark: "#0a0a08",
    },
    text: {
        //primary: "#E97C3B",
        //secondary: "#F98F3C"
        //primary: "#0a0a08",
        //secondary: "#0a0a08",
        primary: "#B64908",
        secondary: "#B64908"
    }
  },
  components: {
    MuiLink: {
      defaultProps: {
        component: LinkBehavior,
      },
    },
    MuiButtonBase: {
      defaultProps: {
        LinkComponent: LinkBehavior,
      },
    },
  },
}));

export default theme;